import instance from "../requst.js";
import { apiRoutes } from "../apiRoutes.js";

export const apiUserLogin = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.userLogin,
    data,
  });
};


export const apiGetAgentInfoPage = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.getAgentInfoPage,
    data,
  });
};


export const apiGetUsersInfoPage = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.getUsersInfoPage,
    data,
  });
};

export const apiGetCommissionLIst = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.commissionLIst,
    data,
  });
};

//新增权限
export const apiAddNewPermission = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.addNewPermission,
    data,
  });
};
//查询所有权限
export const apiGetAllPermission = (data) => {
  return instance({
    method: "get",
    url: apiRoutes.getAllPermission,
    data,
  });
};

//编辑权限
export const apiUpdatePermission = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.updatePermission,
    data,
  });
};
//后台用户列表
export const apiGetAllAdminAccount = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.getAllAdminAccount,
    data,
  });
};
//编辑后台用户
export const apiUpdateAdminUsers = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.updateAdminUsers,
    data,
  });
};


//新增后台用户
export const apiAddAdminUser = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.addAdminUser,
    data,
  });
};

//查询后台用户的权限
export const apiQueryUserPermission = (data) => {
  return instance({
    method: "get",
    url: `${apiRoutes.queryUserPermission}?Id=${data.id}`,
  });
};
//更新后台用户的状态
export const apiUpdateAdminUserStatus = (id) => {
  return instance({
    method: "get",
    url: `${apiRoutes.updateAdminUserStatus}/${id}`,
  });
};
//数据概览
export const apiUserDetailData = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.userDetailData,
    data
  });
};

//数据概览
export const apiAddNewAgent = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.addNewAgent,
    data
  });
};
//代理商列表
export const apiGetAgentList = () => {
  return instance({
    method: "get",
    url: apiRoutes.getAgentList,
  });
};
//代理商列表
export const apiGetAgentDataInfo = (id) => {
  return instance({
    method: "get",
    url: `${apiRoutes.getAgentDataInfo}/${id}`,
  });
};
//编辑代理商列表
export const apiEditAgentDataInfo = (data) => {
  return instance({
    method: "post",
    url: apiRoutes.editAgentDataInfo,
    data
  });
};
//编辑代理商列表
export const apiChanguserAgent = (data) => {
  return instance({
    method: "get",
    url: `${apiRoutes.changuserAgent}/${data.usersId}/${data.agentId}`,
  });
};

